// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3793":"css/app.6644","6741":"css/admin-app.6644"}[chunkId] + ".css";
};